// Supabase client (Supabase Auth for Google + Apple social login).
// The anon/publishable key is safe to ship in the browser; the service-role key must NEVER be here.
// Session persistence + token refresh are handled by the SDK (replaces the old localStorage token).
import { createClient } from '@supabase/supabase-js';

// NO hardcoded fallback project — a missing build arg must fail loudly, never silently
// authenticate against a stale/wrong project. CRA inlines REACT_APP_* at build time.
export const SUPABASE_URL = window._env_?.REACT_APP_SUPABASE_URL || process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_ANON_KEY = window._env_?.REACT_APP_SUPABASE_ANON_KEY || process.env.REACT_APP_SUPABASE_ANON_KEY;

// Belt-and-braces runtime guard: if either value is missing when the app loads, the
// whole app must refuse to proceed (App.js renders a full-screen misconfig page).
const _missing = [
  !SUPABASE_URL && 'REACT_APP_SUPABASE_URL',
  !SUPABASE_ANON_KEY && 'REACT_APP_SUPABASE_ANON_KEY',
].filter(Boolean);

export const SUPABASE_CONFIG_ERROR = _missing.length
  ? `Missing required Supabase configuration: ${_missing.join(' and ')}. `
    + `These are build-time (REACT_APP_*) variables and cannot be set after the bundle is built.`
  : null;

let _supabase = null;
if (!SUPABASE_CONFIG_ERROR) {
  _supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,   // lets the SDK parse the OAuth redirect on /auth/callback
      flowType: 'pkce',
    },
  });
}

export const supabase = _supabase;
